import React, { AllHTMLAttributes, FC, PropsWithChildren } from 'react';

import { cn } from '../../../utils';

import './PaginationHeader.scoped.scss';

interface Props extends AllHTMLAttributes<HTMLDivElement> {}

export const PaginationHeader: FC<PropsWithChildren<Props>> = ({ children, ...props }) => {
  return (
    <div {...props} className={cn('pagination-header', props.className)}>
      {children}
    </div>
  );
};
